import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-name-dialog',
  templateUrl: './name-dialog.component.html',
  styleUrls: ['./name-dialog.component.scss']
})
export class NameDialogComponent implements OnInit {

  nameField = new FormControl(this.title);

  constructor(
    public dialogRef: MatDialogRef<NameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public title: string
  ) { }

  ngOnInit(): void {
    this.nameField.valueChanges.subscribe(name => {
      this.title = name;
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }

  getErrorMessage(): string|undefined {
    if (this.nameField.hasError('required')) {
      return 'You must enter a value';
    }
    return undefined;
  }

}
